module.exports = __webpack_public_path__ + "static/media/s_tennis.362ccf86.mp3";